module.exports = __webpack_public_path__ + "img/toolPic3.a818adbe.png";